module.exports = __webpack_public_path__ + "static/media/catalog_logo.c3c2db04.svg";